import { fetchApiGateway } from "@nova/fetch-api-gateway"

export const fetchTelemetryEvents = ({
    orgId,
    projectId,
    id,
    start,
    end,
}: {
    orgId: string
    projectId: string
    id: string
    start?: number
    end?: number
}) => {
    const query =
        start !== undefined ? `start=${start}${end !== undefined ? `&end=${end}` : ""}` : undefined
    return fetchApiGateway("get /org/:orgId/project/:projectId/telemetry/:id/get-payload", {
        params: { orgId, projectId, id },
        query,
    })
}
